import React from 'react';

import { StyledLabel, Text } from './styles';

export interface LabelProps {
    content: string;
}

export function Label({ content }: LabelProps) {
    return (
        <StyledLabel>
            <Text>{content}</Text>
        </StyledLabel>
    );
}
